
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","viewBox":"0 0 17 17"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"stroke":"#798f8f"}},[_c('path',{staticClass:"i-Vector",attrs:{"stroke-linecap":"round","d":"M5.5 2.5h9m-9 12h9m-9-6h9"}}),_c('path',{staticClass:"i-Vector_2",attrs:{"d":"M3 2.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Z"}}),_c('path',{staticClass:"i-Vector_3",attrs:{"d":"M3 8.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Z"}}),_c('path',{staticClass:"i-Vector_4",attrs:{"d":"M3 14.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Z"}})])])
          )
        }
      }
    